import styled from "styled-components";

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  // min-height: 400px;
  position: relative;
`;

export const ScrollableTableContent = styled.div`
  flex: 1;
  overflow: auto;
  min-height: 0;
  height: calc(100% - 102px);
  padding-bottom: 110px;
`;

export const StyledTable = styled.table`
  width: 100%;
`;

export const TableHeader = styled.thead`
  text-align: left;
`;

export const TableHeaderCell = styled.th`
  border-bottom: 1px solid ${({ theme }) => theme.colors["grey-300"]};
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.colors["grey-300"]};
  padding: ${({ theme }) => `${theme.dimensions.spacing[1]} ${theme.dimensions.spacing[3]}`};
  cursor: pointer;
`;

export const TableCell = styled.td<{ $isLastColumn?: boolean }>`
  padding: 11px 8px;
  ${({ $isLastColumn }) => $isLastColumn && `
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-right: 12px;
  `}
`;

export const EmptyStateContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => theme.dimensions.spacing[4]};
`;

export const EmptyStateImage = styled.img`
  width: 136px;
  margin-bottom: ${({ theme }) => theme.dimensions.spacing[6]};
`;

export const EmptyStateText = styled.div`
  margin-bottom: ${({ theme }) => theme.dimensions.spacing[2]};
  font-size: 14px;
`;

export const EmptyStateSubtext = styled.div`
  color: ${({ theme }) => theme.colors["grey-500"]};
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.colors["white"]};
  z-index: 1000;
  height: 70px;
  position: absolute;
  bottom: 32px;
  left: 0;
  right: 0;
`;